import React from "react";
import { Label } from "semantic-ui-react";

/**
 * Chip de color por rol. Cubre los 13 primary + 4 derived que computa
 * `computeUserRoles` en backend.
 *
 * Paleta:
 *   - admin: rojo (peligro / privilegio maximo)
 *   - partner / partner-child: verde (negocio)
 *   - teacher / student / institution / institution-member: amarillo (Educa)
 *   - therapist / patient / revi-admin: morado (REVI)
 *   - educaSimulator / simulator-admin: cyan (simuladores VR)
 *   - educaverse: azul (mundos virtuales)
 *   - free / user: gris (basico)
 *   - client: olivo
 *   - revi: violeta
 *   - desconocido: negro
 */
const ROLE_COLORS = {
  admin: "red",
  user: "grey",
  client: "olive",
  partner: "green",
  "partner-child": "teal",
  teacher: "yellow",
  student: "orange",
  institution: "yellow",
  "institution-member": "olive",
  therapist: "purple",
  patient: "violet",
  "revi-admin": "purple",
  educaSimulator: "blue",
  "simulator-admin": "blue",
  educaverse: "blue",
  revi: "violet",
  free: "grey",
};

const ROLE_LABELS = {
  admin: "Admin",
  user: "Usuario",
  client: "Cliente",
  partner: "Partner",
  "partner-child": "Sub-partner",
  teacher: "Profesor",
  student: "Alumno",
  institution: "Institucion",
  "institution-member": "Miembro inst.",
  therapist: "Terapeuta",
  patient: "Paciente",
  "revi-admin": "Admin REVI",
  educaSimulator: "Simulador",
  "simulator-admin": "Admin Sim.",
  educaverse: "Educaverse",
  revi: "REVI",
  free: "Free",
};

export function UsersV2RoleTag({ role, size = "small" }) {
  if (!role) return null;
  const color = ROLE_COLORS[role] || "black";
  const label = ROLE_LABELS[role] || role;
  return (
    <Label
      size={size}
      color={color}
      style={{ marginRight: 4, marginBottom: 4 }}
    >
      {label}
    </Label>
  );
}
